<template>
  <div class="container">
    <br>
    <br>
    <footer class="pt-4 my-md-5 pt-md-5 border-top bap-title">
      <div class="row">
        <div class="col-12 col-md">
          <small class="d-block text-muted bap-title"><span class="bap-title"><strong>Sayuri Montrouge - Site Officiel</strong></span></small>
          <small class="d-block text-muted bap-title"><span class="bap-title">115 Avenue Aristide Briand</span></small>
          <small class="d-block text-muted bap-title"><span class="bap-title">92120 Montrouge</span></small>
          <small class="d-block text-muted bap-title"><span class="bap-title">Copyright (c) {{ currentYear }}</span></small>
        </div>

        <div class="col-6 col-md">
          <h6>A Propos</h6>
          <ul class="list-unstyled text-small">

              <li>
                <router-link :to="{name:routeNames.CGV}">
                  Conditions Générales de Ventes - Données Personnelles
                </router-link>
              </li>
            <li>
              <router-link :to="{name:routeNames.LEGAL_MENTIONS}">
                Mentions Légales
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Consts from '@/consts'

export default {
  name: "DefaultFooter",
  components: {},
  data() {
    let currentYear = new Date().getFullYear()  // returns the current year
    return {
      routeNames : Consts.ROUTE_NAMES,
      currentYear: currentYear,
    }
  },
  methods: {
    onClickAdmin(){
      localStorage.setItem('userStatus', "admin");
    }
  }
}
</script>

<style scoped>
</style>
